module.exports = __webpack_public_path__ + "static/img/fieldwork.a6d24a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/my-coin/fieldwork.png
// module id = hakA
// module chunks = 1